export default {
	THANKS: `Thanks for signing up! We'll be in touch with everything you need to know about getting started with Code Kingdoms!`
};
